"use strict";
(function () {
    var pageCssMap = {
        "register.html_zh-cn": "/authui/public/custom/css/zh-cn/registerpage.css",
        "register.html_en-us": "/authui/public/custom/css/en-us/registerpage.css",
        "regSuc.html_zh-cn": "/authui/public/custom/css/zh-cn/registerpage.css",
        "regSuc.html_en-us": "/authui/public/custom/css/en-us/registerpage.css",
        "regFail.html_zh-cn": "/authui/public/custom/css/zh-cn/registerfailed.css",
        "regFail.html_en-us": "/authui/public/custom/css/en-us/registerfailed.css",
        "findPwd.html_zh-cn": "/authui/public/custom/css/zh-cn/fpwd.css",
        "findPwd.html_en-us": "/authui/public/custom/css/en-us/fpwd.css",
        "agencyRegSuc.html_zh-cn": "/authui/public/custom/css/zh-cn/agencyRegisterSuccess.css",
        "agencyRegSuc.html_en-us": "/authui/public/custom/css/en-us/agencyRegisterSuccess.css",
        "reactivate.html_zh-cn": "/authui/public/custom/css/zh-cn/reactivate.css",
        "reactivate.html_en-us": "/authui/public/custom/css/en-us/reactivate.css",
        "findPhone.html_zh-cn": "/authui/public/custom/css/zh-cn/fphone.css",
        "findPhone.html_en-us": "/authui/public/custom/css/en-us/fphone.css",
        "loginVerification.html_zh-cn": "/authui/public/custom/css/zh-cn/loginVerification.css",
        "loginVerification.html_en-us": "/authui/public/custom/css/en-us/loginVerification.css",
        "bindAccount.html_zh-cn": "/authui/public/custom/css/zh-cn/bindAccount.css",
        "bindAccount.html_en-us": "/authui/public/custom/css/en-us/bindAccount.css",
        "bindSuccess.html_zh-cn": "/authui/public/custom/css/zh-cn/bindAccount.css",
        "bindSuccess.html_en-us": "/authui/public/custom/css/en-us/bindAccount.css",
        "createAndBindAccount.html_zh-cn": "/authui/public/custom/css/zh-cn/createAndBindAccount.css",
        "createAndBindAccount.html_en-us": "/authui/public/custom/css/en-us/createAndBindAccount.css",
        "createSubUser.html_zh-cn": "/authui/public/custom/css/zh-cn/createSubUser.css",
        "createSubUser.html_en-us": "/authui/public/custom/css/en-us/createSubUser.css",
        "notify.html_zh-cn": "/authui/public/custom/css/zh-cn/createAndBindAccount.css",
        "notify.html_en-us": "/authui/public/custom/css/en-us/createAndBindAccount.css",
        "resetPwd.html_zh-cn": "/authui/public/custom/css/zh-cn/resetPwd.css",
        "resetPwd.html_en-us": "/authui/public/custom/css/en-us/resetPwd.css",
        "remindBindEmail.html_zh-cn": "/authui/public/custom/css/zh-cn/remindBindEmail.css",
        "remindBindEmail.html_en-us": "/authui/public/custom/css/en-us/remindBindEmail.css",
        "activeAccount.html_zh-cn": "/authui/public/custom/css/zh-cn/activeAccount.css",
        "activeAccount.html_en-us": "/authui/public/custom/css/en-us/activeAccount.css",
        "activeAccountError.html_zh-cn": "/authui/public/custom/css/zh-cn/activeAccountError.css",
        "activeAccountError.html_en-us": "/authui/public/custom/css/en-us/activeAccountError.css",
        // "privacyUpdate.html_zh-cn": "/authui/public/custom/css/zh-cn/privacyUpdate.css",
        // "privacyUpdate.html_en-us": "/authui/public/custom/css/en-us/privacyUpdate.css",
        "welcomeFailed.html_zh-cn": "/authui/public/base/css/welcomeEmail.css",
        "welcomeFailed.html_en-us": "/authui/public/base/css/welcomeEmail.css",
        "welcomeResend.html_zh-cn": "/authui/public/base/css/welcomeEmail.css",
        "welcomeResend.html_en-us": "/authui/public/base/css/welcomeEmail.css",
        "welcomeLogin.html_zh-cn": "/authui/public/base/css/welcomeEmail.css",
        "welcomeLogin.html_en-us": "/authui/public/base/css/welcomeEmail.css",
    };
    
    function getConfig() 
    {
        var config = {
            styleOfSite:""
        };
        return config;
    }
    
    var langTool = new IAM.LanguageTool();
    var styleOfSite = getConfig().styleOfSite;
    if(styleOfSite == "Russia") {
    	langTool.setLocale("en-us");
    } else {
    	var supportLanguage = ['zh-cn', 'en-us', 'es-us', 'pt-br'];
        langTool.setPageLanguage();
        var isSupport = false;
        for (var m in supportLanguage){
            if(window.language === supportLanguage[m]){
                isSupport =true;
                break;
            }
        }
        if(!isSupport){
            if (langTool.ipIsInternational())
                langTool.setLocale("en-us");
            else
                langTool.setLocale("zh-cn");
        }

        // 是否为国际IP
        window.ipIsInternational = langTool.ipIsInternational();
    }
    
    var pathName = window.location.pathname;
    var pageName = pathName.substring(pathName.lastIndexOf("/") + 1);
    if (pageCssMap[pageName + "_" + langTool.getLocale()]) {
        // langTool.addCssToPage(pageCssMap[pageName + "_" + langTool.getLocale()]);
    } else {
        // 引入 banner 和 footer 的整体样式
        // langTool.addCssToPage("/authui/public/custom/css/pageframework.css");

        //login page
        // var map = {
        //     "zh-cn": "/authui/public/custom/css/zh-cn/loginpage.css",
        //     "en-us": "/authui/public/custom/css/en-us/loginpage.css"
        // };
        // langTool.addCssToPage(map[langTool.getLocale()]);
    }
})();


// WEBPACK FOOTER //
// ./public/hws/js/language.js